class Note {
  constructor(data) {
    this.id = data.unique_id || data.id || '';
    this.title = data.title || '';
    this.content = data.content || '';
    this.isShared = data.isShared || data.is_public || false;
    this.shareToken = data.shareToken || null;
    this.createdAt = data.created_at || data.createdAt ? new Date(data.created_at || data.createdAt) : new Date();
    this.updatedAt = data.updated_at || data.updatedAt ? new Date(data.updated_at || data.updatedAt) : new Date();
    this.userId = data.user_id || '';
    this.tags = data.tags || [];
    this.categoryId = data.category_id || data.categoryId || null;
    this.categoryDetails = data.category_details || data.categoryDetails || null;
    this.taskId = data.task_id || data.taskId || null;
    this.summary = data.summary || 'Summary is generating...';
  }

  static fromJson(json) {
    return new Note({
      unique_id: json.unique_id,
      title: json.title,
      content: json.content,
      isShared: json.is_public,
      shareToken: json.share_token,
      createdAt: json.created_at,
      updatedAt: json.updated_at,
      userId: json.user_id,
      tags: json.tags || [],
      categoryId: json.category_id,
      categoryDetails: json.category_details,
      taskId: json.task_id,
      summary: json.summary,
    });
  }

  toJson() {
    return {
      unique_id: this.id,
      title: this.title,
      content: this.content,
      is_public: this.isShared,
      share_token: this.shareToken,
      category_id: this.categoryId,
      tags: this.tags,
      task_id: this.taskId,
      summary: this.summary,
    };
  }

  get formattedCreatedDate() {
    return this.createdAt.toLocaleDateString();
  }

  get formattedUpdatedDate() {
    return this.updatedAt.toLocaleDateString();
  }
  
  
  
  toggleShared() {
    this.isShared = !this.isShared;
    if (!this.isShared) {
      this.shareToken = null;
    }
    return this;
  }
}

export default Note; 